import { supabase } from '@/integrations/supabase/client';

export interface CampaignTemplate {
  id: string;
  company_id: string | null;
  name: string;
  template_type: string;
  subject_template: string;
  body_template: string;
  variables: any;
  category: string | null;
  is_active: boolean;
  status: string;
  template_mode: string;
  usage_count: number;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export async function fetchTemplates(companyId: string): Promise<CampaignTemplate[]> {
  const { data, error } = await supabase
    .from('campaign_email_templates')
    .select('*')
    .eq('company_id', companyId)
    .order('updated_at', { ascending: false });
  if (error) throw error;
  return (data || []) as unknown as CampaignTemplate[];
}

export async function createTemplate(template: Partial<CampaignTemplate>): Promise<CampaignTemplate> {
  const { data, error } = await supabase
    .from('campaign_email_templates')
    .insert(template as any)
    .select()
    .single();
  if (error) throw error;
  return data as unknown as CampaignTemplate;
}

export async function updateTemplate(id: string, updates: Partial<CampaignTemplate>): Promise<CampaignTemplate> {
  const { data, error } = await supabase
    .from('campaign_email_templates')
    .update(updates as any)
    .eq('id', id)
    .select()
    .single();
  if (error) throw error;
  return data as unknown as CampaignTemplate;
}

export async function deleteTemplate(id: string): Promise<void> {
  const { error } = await supabase
    .from('campaign_email_templates')
    .delete()
    .eq('id', id);
  if (error) throw error;
}
